import gql from 'graphql-tag';

import { AssetFieldsFragment } from 'compositions/CaseRequestsPanel/CaseRequestsPanelContext/constants';

const NAME = 'compositions_CaseRequestsPanel_caseAssetsQuery';

export default gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      primaryAsset { ...AssetFields }
      relatedAssets { ...AssetFields }
    }
  }
  ${AssetFieldsFragment}
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withCaseAssets/caseAssetsQuery.js